import { useMutation, useQueryClient } from "react-query";

import { crearComuna, updateComuna, deleteComuna} from '../../services/Comunas';

import { toast } from 'react-hot-toast';
const queryKey = "comunas";

export const useComunasMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addComuna = useMutation((body) => crearComuna(body), {
    onSuccess,
    onError: (err) => onError(err),
  });
  const updateComunaD = useMutation(
    (body) => updateComuna( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removeComuna = useMutation((id) => deleteComuna( id), {
    onSuccess,
    onError,
  });

  return { addComuna, updateComunaD, removeComuna };
};
export default useComunasMutations;